import React from "react";
import { Link } from "react-router-dom";
import "./MobileFooter.css";

/**
 * Compact footer for mobile bottom sheet
 */
const MobileFooter = () => {
  return (
    <div className="mobile-footer">
      <div className="mobile-footer-links">
        <Link to="/events" className="mobile-footer-link">Events</Link>
        <span className="mobile-footer-divider">·</span>
        <Link to="/about" className="mobile-footer-link">About</Link>
        <span className="mobile-footer-divider">·</span>
        <Link to="/contact" className="mobile-footer-link">Contact</Link>
      </div>
      <div className="mobile-footer-copyright">
        © {new Date().getFullYear()} VegifyIt
      </div>
    </div>
  );
};

export default MobileFooter;
